export var CustomPDFReportType;
(function (CustomPDFReportType) {
    CustomPDFReportType["AGGREGATE_SECURITY_COMPARISON"] = "aggregate_security_comparison";
    CustomPDFReportType["AGGREGATE_SECURITY_OVERVIEW"] = "aggregate_security_overview";
    CustomPDFReportType["MULTI_SECURITY_COMPARISON"] = "multi_security_comparison";
    CustomPDFReportType["PRESENTATION"] = "presentation";
    CustomPDFReportType["TEARSHEET_MULTI_SECURITY_COMPARISON"] = "tearsheet_multi_security_comparison";
    CustomPDFReportType["TEARSHEET_SINGLE_SECURITY"] = "tearsheet_single_security";
})(CustomPDFReportType || (CustomPDFReportType = {}));
